import type { IDeviceSession } from '../services/device-service';

// The sessions API returns each session as a Mongo shell string (ObjectId(...), ISODate(...), bare keys).
const parseMongoSession = (sessionStr: string) => {
  try {
    const cleanedJson = sessionStr
      .replace(/ObjectId\("([^"]*)"\)/g, '"$1"')
      .replace(/ISODate\("([^"]*)"\)/g, '"$1"')
      .replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

    return JSON.parse(cleanedJson);
  } catch (error) {
    console.error('Error parsing session:', error);
    return null;
  }
};

/** Turns the raw sessions response into typed sessions, skipping any that cannot be read. */
export const parseDeviceSessions = (sessions: unknown): IDeviceSession[] => {
  if (!Array.isArray(sessions)) return [];

  return (sessions as string[])
    .map((sessionStr) => {
      const parsed = parseMongoSession(sessionStr);
      if (!parsed) return null;

      return {
        ...parsed,
        IssuedUtc: new Date(parsed.IssuedUtc),
        ExpiresUtc: new Date(parsed.ExpiresUtc),
        CreateDate: new Date(parsed.CreateDate),
        UpdateDate: new Date(parsed.UpdateDate.$date),
      } as IDeviceSession;
    })
    .filter((session): session is IDeviceSession => session !== null);
};
